import {
  useV2ListQuestionsForQuestionnaireQuery,
  useV2ListQuestionnaireLookupsForQuestionnaireQuery,
  useV2ListQuestionnaireCalculationsForQuestionnaireQuery,
} from "@generated";
import type { Operand } from "../types";

// Operands that return a number: number questions + number lookups + all calculations.
export const useRecommendationOperands = (questionnaireId: string) => {
  const qid = Number(questionnaireId);
  const args = {
    questionnaireId: qid,
    filter: { active: true },
    page: { size: 500 },
  } as const;
  const opt = { refetchOnMountOrArgChange: true } as const;
  const { data: qData } = useV2ListQuestionsForQuestionnaireQuery(args, opt);
  const { data: lData } = useV2ListQuestionnaireLookupsForQuestionnaireQuery(
    args,
    opt
  );
  const { data: cData } =
    useV2ListQuestionnaireCalculationsForQuestionnaireQuery(args, opt);

  const toOperand = (x: any): Operand => ({
    slug: x.attributes?.slug ?? "",
    name: x.attributes?.name ?? "",
  });
  const numberOnly = (rows: any[]) =>
    rows.filter((x) => x.attributes?.["value-type"] === "number");

  const operands: Operand[] = [
    ...numberOnly(qData?.data ?? []).map(toOperand),
    ...numberOnly(lData?.data ?? []).map(toOperand),
    ...(cData?.data ?? []).map(toOperand),
  ]
    .filter((o) => o.slug !== "")
    .sort((a, b) => a.name.localeCompare(b.name));

  return { operands };
};

export default useRecommendationOperands;
